import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AxiosInstance } from "../../../../axios";
import styles from "./CourierCharges.module.css";
import { useNavigate } from "react-router-dom";
// import ConfirmationPopup from "../TestAdminWorkflow/Gallery/ConfirmationPopup/ConfirmationPopup";
import Loader from "../../Loader";
import { Chip, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { R_PER_PAGE } from "../../../../labels";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import moment from "moment";
import DatePickerSample from "../../DatePicker";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import toast from "react-hot-toast";

function ListCouierCharges() {
  const location = useLocation();
  const { filter_status, filter_date } = location.state || {};
  const [status, setStatus] = useState([]);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  const [updateChipData, setUpdateChipData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [isLoading, setIsLoading] = useState(false);
  const filterRef = useRef(null);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState({
    type: false,
    category: false,
    status: false,
    created_dt: false,
  });
  const [appDatas, setAppDatas] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [appOns, setAppOns] = useState([]);

  const fDatePickerRef = useRef();
  const tDatePickerRef = useRef();
  const filterLastRef = useRef();
  const userJSON = sessionStorage.getItem("userDetails");
  let page = R_PER_PAGE;
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [csvData, setCsvData] = useState([]);
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  let filterStatus = [];
  let filterApplyeds = [];
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleSort = (event, sortKey) => {
    event.preventDefault();

    const order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);

    const sortedList = [...filteredData].sort((a, b) => {
      let valA = a[sortKey] ?? "";
      let valB = b[sortKey] ?? "";

      const isNumber = !isNaN(valA) && !isNaN(valB);

      if (isNumber) {
        return order === "asc"
          ? Number(valA) - Number(valB)
          : Number(valB) - Number(valA);
      } else {
        valA = valA.toString().toLowerCase();
        valB = valB.toString().toLowerCase();

        return order === "asc"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }
    });

    setFilteredData(sortedList);
  };
  useEffect(() => {
    filterStatus = status;
  }, [status]);
  useEffect(() => {
    filterApplyeds = appOns;
  }, [appDatas]);
  // API call to get district list

  useEffect(() => {
    if (filter_status && filter_status.length > 0) {
      setStatus(filter_status);
      filterStatus = filter_status;
    } else {
      setStatus(status);
      filterStatus = status;
    }
    if (filter_date && filter_date.length > 0) {
      const filterDates = filter_date[0];
      setAppDatas({
        FDate: filterDates.fdate,
        TDate: filterDates.edate,
        Days: filterDates.Days,
        name: "",
      });
      setAppOns(filter_date);
      filterApplyeds = filter_date;
    }
    setIsFiltersInitialized(true);
    loadChipdata();
  }, [filter_status, filter_date]);

  useEffect(() => {
    if (isFiltersInitialized && filter_status && filter_status.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && filter_date && filter_date.length > 0) {
      loadListdata();
    }
  }, [filter_status, filter_date, isFiltersInitialized, updateChipData]);
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
    }
  }, [isFiltersInitialized, updateChipData]);

  function updateStateData() {
    filterStatus = status;
    filterApplyeds = appOns;
  }

  function loadChipdata() {
    let tempArr = [];

    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyeds.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }
  const handleAllClear = () => {
    setStatus([]);
    setUpdateChipData([]);
    setAppOns([]);
    setAppDatas({
      FDate: "",
      TDate: "",
      Days: "",
    });
    loadListdata();
  };

  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = filteredData.slice(start, end);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        const hasStatus = updateChipData.some(
          (chipItem) => chipItem.type === "status"
        );
        if (hasStatus) {
          const updatedStatus = updateChipData.filter(
            (chipItem) => chipItem.type === "status"
          );
          setStatus(updatedStatus);
        } else {
          setStatus([]);
        }

        setIsOpen((prev) => ({ ...prev, status: false }));
      }

      // Created_dt filter close logic
      // if (
      //   filterLastRef.current &&
      //   !filterLastRef.current.contains(event.target)
      // ) {
      //   const mismatchedDay = updateChipData.find(
      //     (chipItem) => chipItem.Days && chipItem.Days === appDatas.Days
      //   );
      //   if (mismatchedDay) {
      //     setAppDatas({
      //       FDate: "",
      //       TDate: "",
      //       Days: mismatchedDay.Days,
      //     });
      //     setAppOns([
      //       {
      //         name: mismatchedDay.name || "",
      //         FDate: "",
      //         TDate: "",
      //         Days: mismatchedDay.Days,
      //       },
      //     ]);
      //   } else {
      //     const mismatchedDate = updateChipData.find(
      //       (chipItem) =>
      //         chipItem.fdate === appDatas.FDate &&
      //         chipItem.edate === appDatas.TDate
      //     );
      //     if (mismatchedDate) {
      //       setAppDatas((prev) => ({
      //         ...prev,
      //         FDate: mismatchedDate.fdate,
      //         TDate: mismatchedDate.edate,
      //         Days: "",
      //       }));
      //       setAppOns([
      //         {
      //           name:
      //             mismatchedDate.name ||
      //             `${mismatchedDate.fdate} - ${mismatchedDate.edate}`,
      //           FDate: mismatchedDate.fdate,
      //           TDate: mismatchedDate.edate,
      //           Days: "",
      //         },
      //       ]);
      //     } else {
      //       setAppDatas({
      //         FDate: "",
      //         TDate: "",
      //         Days: "",
      //       });
      //       setAppOns([]);
      //     }
      //   }
      //   setIsOpen((prev) => ({ ...prev, startDates: false }));
      // }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData, status]);

  const loadListdata = () => {
    setIsLoading(true);

    const payload = {
      start_date: appOns.length > 0 ? appOns[0].fdate || appOns[0].FDate : "",
      end_date: appOns.length > 0 ? appOns[0].edate || appOns[0].TDate : "",
      is_active: status.length > 0 ? status[0]?.id : "",
    };

    AxiosInstance.post("/api/book/courier/list", payload)
      .then((res) => {
        if (res.data.data) {
          setIsLoading(false);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setCurrentPage(1);
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            weightRange: `${item.start_gram_range} - ${item.end_gram_range}`,
            amount: item.amount,
            displayDate: item.created_dt
              ? moment(item.created_dt).format("DD/MM/YYYY")
              : "",
            isActive:
              item.isActive === 0
                ? "InActive"
                : item.isActive === 1
                ? "Active"
                : "",
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
          setFilteredData(serialNumberAddedData);
        } else {
          setFilteredData([]);
          setIsLoading(false);
        }
      })
      .catch(() => {
        setFilteredData([]);
        setIsLoading(false);
      });
  };
  const handleDelete = (chipToDelete) => () => {
    updateStateData();
    if (chipToDelete.type === "status") {
      setStatus(status.filter((item) => item.id !== chipToDelete.id));
      filterStatus = status.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "dayRanges") {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
    } else {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
    }
    loadChipdata();
  };

  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        type: false,
        status: !prevState.status,
      }));
      setStatus(updateChipData.filter((ui) => ui.type === "status"));
    } else if (boxName === "appliedOn") {
      setIsOpen((prevState) => ({
        seriesTag: false,
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
        is_ebook: false,
        is_free_book: false,
        medium: false,
        startDates: !prevState.startDates,
      }));
    }
  };

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "status") {
      if (checked) {
        setStatus([{ id: value, name: name, type: "status" }]);
      } else {
        setStatus(status.filter((item) => item.id !== value));
      }
    }
  };
  const handleClear = (name, event) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      type: false,
      category: false,
      status: false,
      created_dt: false,
    });
    updateStateData();
    if (name === "status") {
      updateStateData();
      setStatus([]);
      filterStatus = [];
      setIsOpen({
        ...isOpen,
        status: false,
      });
      loadChipdata();
    } else if (name === "appliedOns") {
      updateStateData();
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
      setIsOpen({
        ...isOpen,
        startDates: false,
      });
    }
    setTimeout(() => {
      loadChipdata();
    }, 500);
  };

  const handleApplyFilter = (name, event) => {
    updateStateData();

    if (name === "status") {
      loadChipdata();
      setCurrentPage(1);
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "appliedOns") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        startDates: false,
      });
    }
  };

  const handleChangeDate_app = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppDatas((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };
        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOns([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  useEffect(() => {
    loadListdata();
  }, [updateChipData]);

  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, []);

  useEffect(() => {
    if (location.state) {
      // Optionally do something here if needed
    }
  }, [location.state]);

  const handleReadView = (id) => {
    const formattedAppOns = appOns.map((item) => ({
      name:
        item.name ||
        (item.FDate && item.TDate ? `${item.FDate} - ${item.TDate}` : ""),
      fdate: item.fdate || item.FDate,
      edate: item.edate || item.TDate,
      type: item.type || "dateRange",
    }));
    navigate(`/ViewCourierCharges/${id}`, {
      state: {
        STATUS: status,
        DATE: formattedAppOns,
      },
    });
  };

  const generatePDF = () => {
    const headers = ["S.No", "Weight Range", "Amount", "Created On", "Status"];

    const rows = csvData.map((item, index) => [
      index + 1,
      item.weightRange ?? "",
      item.amount ?? "",
      item.displayDate ?? "",
      item.isActive ?? "",
    ]);

    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Courier Charge Data",
          headers,
          rows,
          filename: "CourierCharge.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Weight Range (in grams)", key: "weightRange" },
    { label: "Amount", key: "amount" },
    { label: "Created Date", key: "displayDate" },
    { label: "Status", key: "isActive" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      <div className="container-fluid global_container BathDet BathHeader mb-5 p-0">
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">Courier Charges</h2>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul className="List-Button">
              <li class="ListBtnItems">
                <CustomDownloadButton
                  csvListData={csvData?.length > 0 ? csvData : ""}
                  headers={csvHeaders}
                  iconName=" file_download "
                  filename={"Couriercharges.csv"}
                  csvName="  Download as CSV"
                />
              </li>
              <li class="ListBtnItems primaryButton" onClick={generatePDF}>
                <span className="material-icons me-1 align-middle text-white">
                  file_download
                </span>
                Download as PDF
              </li>
              <li className="ListBtnItems">
                <Link to="/CreateCourierCharges" className="primaryButton">
                  Create New Courier Charge
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {updateChipData.length > 0 ? (
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-xs-12 paperil_global ">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {updateChipData.map((data, index) => {
                  let icon;
                  let key = "" + data?.name;
                  return (
                    <ListItem key={data}>
                      <Chip
                        icon={icon}
                        label={key}
                        onDelete={handleDelete(data, index)}
                      />
                    </ListItem>
                  );
                })}
                <ListItem className="clearAll_list">
                  <a
                    className="clearAll_listItem"
                    href="javascript:void(0)"
                    onClick={handleAllClear}
                  >
                    Clear All Filters
                  </a>
                </ListItem>
              </Paper>
            </div>
          </div>
        ) : (
          <div></div>
        )}

        {/* Table */}
        <div className="row mt-2 mx-0">
          <div className="col-md-12 table-responsive tableMinHeight px-0">
            <table className="table" id="tableListHeader">
              <thead>
                <tr>
                  {/* S.No */}
                  <th>
                    <span onClick={(e) => handleSort(e, "serialNumber")}>
                      S.No
                    </span>
                    <span
                      className="material-icons textHead_th align-middle"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Weight Range */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "start_gram_range")}
                    >
                      Weight Range (in grams)
                    </span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "start_gram_range")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Amount */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "amount")}
                    >
                      Amount
                    </span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "amount")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Created on */}
                  <th
                    id="th"
                    className={styles.tableThPadding}
                    ref={filterLastRef}
                  >
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "created_dt")}
                    >
                      {" "}
                      Created On
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "created_dt")}
                    >
                      import_export
                    </span>

                    <span
                      onClick={(e) => handleFilter(e, "appliedOn")}
                      class={` align-middle material-icons ${
                        (appDatas &&
                          Object.entries(appDatas).some(
                            ([key, val]) =>
                              key !== "name" &&
                              val !== null &&
                              val !== undefined &&
                              val.toString().trim() !== ""
                          )) ||
                        isOpen.startDates
                          ? styles.active_icons_book
                          : ""
                      }`}
                    >
                      filter_list
                    </span>
                    {isOpen.startDates === true && (
                      <div className=" filterBoxs_testlist container mt-2   p-1">
                        <div className="row mt-1">
                          <div className="col-md-12">
                            <div class="form-check p-1">
                              <label
                                htmlFor="FDate"
                                className="d-flex form-label"
                              >
                                From Date
                                <span
                                  data-required="true"
                                  aria-hidden="true"
                                ></span>
                              </label>
                              {/* <input
                                                                                                 /> */}
                              <DatePickerSample
                                IconInput={"filterIocnBoxInput"}
                                class={"FilterInputs"}
                                name={"FDate"}
                                handleChange={handleChangeDate_app}
                                fieldInput={appDatas.FDate}
                                txtAdMDob={fDatePickerRef}
                                // maxDate={new Date()}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-12">
                            <div class="form-check p-1">
                              <label
                                htmlFor="TDate "
                                className="d-flex form-label"
                              >
                                To Date
                                <span
                                  data-required="true"
                                  aria-hidden="true"
                                ></span>
                              </label>
                              {/* <input
                                                                                                 /> */}
                              <DatePickerSample
                                class={"FilterInputs"}
                                IconInput={"filterIocnBoxInput"}
                                name={"TDate"}
                                handleChange={handleChangeDate_app}
                                fieldInput={appDatas.TDate}
                                txtAdMDob={tDatePickerRef}
                                minDate={appDatas.FDate}
                              />
                            </div>
                          </div>
                        </div>
                        {/* <div className="row mt-2">
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              id="Today"
                              value="Today"
                              checked={appDatas.Days === "Today"}
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Today"
                              htmlFor="Today"
                              style={{ fontWeight: "bold" }}
                            >
                              Today
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Yesterday"
                              checked={appDatas.Days === "Yesterday"}
                              id="Yesterday"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Yesterday"
                              htmlFor="Yesterday"
                              style={{ fontWeight: "bold" }}
                            >
                              Yesterday
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tweek"
                              checked={appDatas.Days === "Tweek"}
                              id="Tweek"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tweek"
                              htmlFor="Tweek"
                              style={{ fontWeight: "bold" }}
                            >
                              This week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Lweek"
                              checked={appDatas.Days === "Lweek"}
                              id="Lweek"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lweek"
                              htmlFor="Lweek"
                              style={{ fontWeight: "bold" }}
                            >
                              Last week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tmonth"
                              checked={appDatas.Days === "Tmonth"}
                              id="Tmonth"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tmonth"
                              htmlFor="Tmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              This month
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              checked={appDatas.Days === "Lmonth"}
                              value="Lmonth"
                              id="Lmonth"
                              onChange={handleAppliedOns}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lmonth"
                              htmlFor="Lmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              Last month
                            </label>
                          </div>
                        </div>
                      </div> */}
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4  col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("appliedOns")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              onClick={() => handleApplyFilter("appliedOns")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </th>
                  {/* status */}
                  <th ref={filterRef}>
                    <span onClick={(e) => handleSort(e, "is_active")}>
                      Status
                    </span>
                    <span
                      className="material-icons textHead_th align-middle"
                      onClick={(e) => handleSort(e, "is_active")}
                    >
                      import_export
                    </span>
                    <span
                      class={` align-middle material-icons  ${
                        status?.length > 0 || isOpen.status
                          ? styles.active_icons_book
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "status")}
                    >
                      filter_list
                    </span>

                    {isOpen.status && (
                      <>
                        <div className="filterBoxs_testlist mt-2">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={"Active"}
                                  value={1}
                                  checked={status.some((element) => {
                                    if (element.id == 1) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  id={"Active"}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "status", "status")
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText bg-green"
                                  htmlFor={"Active"}
                                >
                                  Active
                                </label>
                              </li>
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={"Inactive"}
                                  value={0}
                                  checked={status.some((element) => {
                                    if (element.id == 0) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  id={"Inactive"}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "status", "status")
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText bg-danger"
                                  htmlFor={"Inactive"}
                                >
                                  Inactive
                                </label>
                              </li>
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleClear("status")}
                                  className="secondaryButton "
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  disabled={status.length === 0 ? true : false}
                                  onClick={() => handleApplyFilter("status")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>
                  <th>
                    <span>Action</span>
                  </th>
                </tr>
              </thead>

              <tbody>
                {currentData.length === 0 ||
                (currentData.length === 1 && currentData[0].data) ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData?.map((course, index) => (
                    <tr key={index}>
                      <td id="td">{course.serialNumber} </td>
                      <td id="td">
                        {course.start_gram_range} - {course.end_gram_range}{" "}
                      </td>
                      <td id="td">{course.amount} </td>
                      <td id="td">
                        {moment(course.created_dt).format("YYYY/MM/DD")}
                      </td>
                      {course.isActive == 0 && (
                        <td id={`${styles.td}`}>
                          <span class="filterChipText bg-danger mx-0 ">
                            InActive
                          </span>
                        </td>
                      )}
                      {course.isActive == 1 && (
                        <td id={`${styles.td}`}>
                          <span class="filterChipText bg-green mx-0 ">
                            Active
                          </span>
                        </td>
                      )}
                      <td id="td">
                        <button
                          className={"view_icon_button"}
                          onClick={() => handleReadView(course.id)}
                        >
                          <span className={`visibleicon material-icons`}>
                            visibility
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className={`${styles.paginationRow} row mt-2`}>
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              currentData && currentData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              currentData && currentData?.length > 0
                ? currentPage * rowsPerPage >= filteredData?.length
                  ? filteredData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={
              filteredData && filteredData?.length > 0
                ? filteredData?.length
                : 0
            }
            handlePrev={(e) => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1 || totalPages === 0}
            prevButton={`${styles.prev_buttonView} ${styles.materialIconsRightAndLeft} me-2`}
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages || totalPages === 0}
          />
        </div>
      </div>
    </>
  );
}

export default ListCouierCharges;
